import _toConsumableArray from "/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.object.to-string.js";
/**
   * 标签输入框组件
   * @module $ui/components/my-form/src/common/TagInput
   */
import { Select, Tag, Input } from 'element-ui';
import { addResizeListener, removeResizeListener } from 'element-ui/lib/utils/resize-event';
import { isEqual } from '@/utils/util';
export default {
  components: {
    Select: Select,
    Tag: Tag,
    ElInput: Input
  },
  /**
     * 属性参数
     * @member props
     * @property {array} [value] 初始值，支持双向绑定
     * @property {string} [size] 尺寸，可选值'medium', 'small', 'mini', ''
     * @property {boolean} [disabled] 禁用
     * @property {boolean} [readonly] 只读
     * @property {boolean} [collapseTags] 折叠标签
     * @property {string} [placeholder] 输入框占位文本
     * @property {boolean} [closable=true] 允许删除标签
     * @property {boolean} [allowCreate=true] 允许创建标签
     * @property {string} [icon=el-icon-price-tag] 输入框后缀的图标样式
     *
     */
  props: {
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    size: {
      type: String,
      default: '',
      validator: function validator(val) {
        return ['medium', 'small', 'mini', ''].includes(val);
      }
    },
    disabled: Boolean,
    readonly: Boolean,
    collapseTags: Boolean,
    placeholder: String,
    closable: {
      type: Boolean,
      default: true
    },
    // 允许新增
    allowCreate: {
      type: Boolean,
      default: true
    },
    icon: {
      type: String,
      default: 'el-icon-price-tag'
    }
  },
  data: function data() {
    return {
      initialInputHeight: 0,
      inputLength: 100,
      inputWidth: 0,
      tags: [],
      query: ''
    };
  },
  computed: {
    classes: function classes() {
      return _defineProperty({
        'el-select': true
      }, "el-select--".concat(this.size), !!this.size);
    },
    tagSize: function tagSize() {
      return ['small', 'mini'].includes(this.size) ? 'mini' : 'small';
    },
    inputStyle: function inputStyle() {
      return {
        flexGrow: 1,
        width: "".concat(this.inputLength / (this.inputWidth - 32), "%"),
        maxWidth: "".concat(this.inputWidth - 42, "px"),
        minWidth: '50px'
      };
    },
    showPlaceholder: function showPlaceholder() {
      return this.tags.length > 0 || this.query ? '' : this.placeholder;
    },
    closableTag: function closableTag() {
      return this.closable && !this.disabled && !this.readonly;
    }
  },
  watch: {
    value: {
      immediate: true,
      handler: function handler(val) {
        if (!isEqual(val, this.tags)) {
          this.tags = _toConsumableArray(val);
        }
      }
    },
    query: function query(val) {
      /**
         * 输入框文字改变时触发
         * @event input-change
         * @param {string} val 输入框文本
         */
      this.$emit('input-change', val);
    },
    tags: function tags(val) {
      /**
         * 输入框标签改变时触发
         * @event change
         * @param {Array} [tags] 标签
         */
      this.$emit('change', val);
      this.$emit('input', val);
    }
  },
  mounted: function mounted() {
    addResizeListener(this.$refs.tags, this.handleResize);
    this.setInitialInputHeight();
  },
  beforeDestroy: function beforeDestroy() {
    removeResizeListener(this.$refs.tags, this.handleResize);
  },
  methods: {
    setInitialInputHeight: function setInitialInputHeight() {
      var sizeMap = {
        medium: 36,
        small: 32,
        mini: 28
      };
      this.initialInputHeight = sizeMap[this.size] || 40;
    },
    handleResize: function handleResize() {
      this.resetInputWidth();
      this.resetInputHeight();
    },
    resetInputWidth: function resetInputWidth() {
      this.inputWidth = this.$refs.reference.$el.getBoundingClientRect().width;
    },
    resetInputHeight: function resetInputHeight() {
      var _this = this;
      if (this.collapseTags) return;
      this.$nextTick(function () {
        if (!_this.$refs.reference) return;
        var inputChildNodes = _this.$refs.reference.$el.childNodes;
        var input = [].filter.call(inputChildNodes, function (item) {
          return item.tagName === 'INPUT';
        })[0];
        var tags = _this.$refs.tags;
        var sizeInMap = _this.initialInputHeight || 40;
        input.style.height = _this.tags.length === 0 ? sizeInMap + 'px' : Math.max(tags ? tags.clientHeight + (tags.clientHeight > sizeInMap ? 6 : 0) : 0, sizeInMap) + 'px';
      });
    },
    focus: function focus() {
      this.$refs.input && this.$refs.input.focus();
      this.$emit('focus');
    },
    blur: function blur() {
      this.$refs.input && this.$refs.input.blur();
      this.$emit('blur');
    },
    removeTag: function removeTag(index) {
      if (index > -1) {
        var tag = this.tags[index];
        this.tags.splice(index, 1);
        this.query = '';
        /**
           * 删除标签时触发
           * @event remove
           * @param {Number} index 标签所在索引
           * @param {*} tag 标签
           */
        this.$emit('remove', index, tag);
      }
    },
    select: function select() {
      if (!this.allowCreate) return;
      if (!this.query) return;
      this.tags.push(this.query);
      /**
         * 新增标签时触发
         * @event add
         * @param {string} [tag] 标签
         */
      this.$emit('add', this.query);
      this.query = '';
    }
  }
};